import React from "react";
import Skeleton from "./Skeleton";

function SkeletonTransactionItem() {
  return (
    <div className="v1-tx-item sk-tx-item">
      <Skeleton width={44} height={44} borderRadius="12px" />
      <div className="v1-tx-meta">
        <Skeleton width={80} height={14} />
        <Skeleton width={130} height={12} className="sk-tx-sub" />
      </div>
      <Skeleton width={64} height={14} />
    </div>
  );
}

export default SkeletonTransactionItem;
